/**
 * Formats a duration in milliseconds to a human-readable string.
 *
 * Values below 1000ms are displayed as whole milliseconds.
 * Values at or above 1000ms are displayed as whole seconds (rounded).
 *
 * The threshold check is performed on the raw `ms` value, not the rounded
 * value. For example, `ms = 999.6` stays in the milliseconds branch even
 * though `Math.round(999.6)` equals 1000.
 *
 * @param ms - Duration in milliseconds
 * @returns Formatted string, e.g. "500 milliseconds" or "2 seconds"
 */
export function formatExecutionTime(ms: number): string {
  if (ms >= 1000) {
    return `${Math.round(ms / 1000)} seconds`;
  }
  return `${Math.round(ms)} milliseconds`;
}
